module.exports = __webpack_public_path__ + "static/media/cases_ident_visual_bd_05.28dc8a70.jpg";